<template>
  <div class="template-padding">
    <h4 class="font-weight-bolder">
      Crew Monitoring Report
    </h4> <hr class="hr-color">

    <div class="card">
      <div class="card-header p-1">
        <div class="font-weight-bold">
          Advanced Search
        </div>
      </div>
      <div class="card-body p-1">
        <!-- SPACE FOR ADVANCED SEARCH -->
<!--        <div class="row no-gutters pt-2">-->

<!--          <div class="col col-auto px-2">-->
<!--            <div class="font-weight-bolder h6">Training Providers</div>-->
<!--            <div class="col-auto form-inline pb-1" v-for="trainingProviderKey in trainingProviderKeys"-->
<!--                 :key="trainingProviderKey.id"-->
<!--                 :title="trainingProviderKey.name"-->
<!--            >-->
<!--              <input type="checkbox" :id="`training-provider-${trainingProviderKey.id}`"-->
<!--                     :value="trainingProviderKey.id"-->
<!--                     v-model="params.trainingProviders"-->
<!--              >-->
<!--              <label :for="`training-provider-${trainingProviderKey.id}`" class="input-group-prepend small ml-2"-->
<!--                     :class="{'font-weight-bolder': params.trainingProviders.includes(trainingProviderKey.id)}"-->
<!--              >-->
<!--                {{trainingProviderKey.code}}-->
<!--              </label>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="col col-auto px-2">-->
<!--            <div class="font-weight-bolder h6">RANK TYPES</div>-->
<!--            <div class="col-auto form-inline pb-1" v-for="rankType in rankTypeWithRanks"-->
<!--                 :key="rankType.id"-->
<!--            >-->
<!--              <input type="checkbox" :id="`rank-type-${rankType.id}`"-->
<!--                     :value="rankType.id"-->
<!--                     v-model="params.rankTypes"-->
<!--              >-->
<!--              <label :for="`rank-type-${rankType.id}`" class="input-group-prepend small ml-2"-->
<!--                     :class="{'font-weight-bolder': params.rankTypes.includes(rankType.id)}"-->
<!--              >-->
<!--                {{rankType.name}}-->
<!--              </label>-->
<!--            </div>-->
<!--          </div>-->

<!--        </div>-->



        <div class="row pl-3">
          <div class="col col-sm-4 pl-0">

            <div
              class="tab-content gray-border float-right w-80"
              id="nav-tabContent"
              style="left: -1px;"
            >
              <div
                class="tab-pane fade show"
                role="tabpanel"
                :aria-labelledby="'#list' + provider.id"
                :id="'tab' + provider.id"
                v-for="(provider, tabIndex) in providerWithCourses"
                :key="provider.id"
                :class="{'active': tabIndex === 0}"
              >
                <div class="font-weight-bolder text-left">
                  <div class="form-group form-row m-0">
                    <div class="col col-sm-1 my-auto">
                      <input
                        type="checkbox"
                        class="form-control form-control-xs"
                        @click="selectCourseProviderByIndex"
                      >
                    </div>
                    <div class="col col-sm-11 col-form-label py-1">
                      {{ provider.code }} Courses
                    </div>
                  </div>
                </div>
                <hr class="m-0">
                <div class="overflow-auto" style="min-height: 10vh; max-height: 25vh">
                  <div
                    class="form-group form-row m-0"
                    v-for="course in provider.courses"
                    :key="course.matrixId"
                    :class="{'bg-gradient-success': params.courseTrainingProviders.some(courseTrainingProvider => courseTrainingProvider === course.matrixId)}"
                  >
                    <div class="col col-sm-1 my-auto">
                      <input
                        type="checkbox"
                        :id="`training-provider-${course.matrixId}`"
                        :value="course.matrixId"
                        v-model="params.courseTrainingProviders"
                      >
                    </div>
                    <label class="col col-sm-11 col-form-label py-0 small"
                           :for="`training-provider-${course.matrixId}`"
                    >
                      {{ course.course }}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <ul
              class="nav nav-tabs flex-column text-right mr-0 float-right w-20"
              role="tablist"
            >
              <li
                class="nav-item highlight-tab"
                v-for="(provider, index) in providerWithCourses"
                :key="provider.id"
              >
                <a
                  class="nav-link p-0 test rounded-0"
                  role="tab"
                  data-toggle="list"
                  :id="'list' + provider.id"
                  :href="'#tab' + provider.id"
                  :aria-controls="provider.id"
                  :class="{'active': index === 0}"
                  @click="switchProviderIndex(index)"
                >
                  <small class="font-weight-bold">{{ provider.code }}</small>
                </a>
              </li>
            </ul>
          </div>

          <div class="col col-sm-4 pl-0">
            <div
              class="tab-content gray-border float-right w-80"
              id="rank-tabContent"
              style="left: -1px;"
            >
              <div
                class="tab-pane fade show"
                role="tabpanel"
                :aria-labelledby="'#listrank' + rankType.id"
                :id="'tabrank' + rankType.id"
                v-for="(rankType, tabIndex) in rankTypeWithRanks"
                :key="rankType.id"
                :class="{'active': tabIndex === 0}"
              >
                <div class="font-weight-bolder text-left">
                  <div class="form-group form-row m-0">
                    <div class="col col-sm-1 my-auto">
                      <input
                        type="checkbox"
                        class="form-control form-control-xs"
                        @click="selectRanksByRankTypeIndex"
                      >
                    </div>
                    <div class="col col-sm-11 col-form-label py-1">
                      {{ rankType.name }} Ranks
                    </div>
                  </div>
                </div> <hr class="m-0">
                <div class="overflow-auto" style="min-height: 10vh; max-height: 25vh">
                  <div
                    class="form-group form-row m-0"
                    v-for="rank in rankType.ranks"
                    :key="rank.id"
                    :class="{'bg-gradient-success': params.ranks.some(addedRank => addedRank === rank.id)}"
                  >
                    <div class="col col-sm-1">
                      <input
                        type="checkbox"
                        name="status"
                        id="status"
                        :value="rank.id"
                        v-model="params.ranks"
                        class="form-control form-control-xs"
                      >
                    </div>
                    <div class="col col-sm-11 col-form-label py-1">
                      {{ rank.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ul
              class="nav nav-tabs flex-column text-right mr-0 float-right w-20"
              role="tablist"
            >
              <li
                class="nav-item highlight-tab"
                v-for="(rankType, index) in rankTypeWithRanks"
                :key="rankType.id"
              >
                <a
                  class="nav-link p-0 test rounded-0"
                  role="tab"
                  data-toggle="list"
                  :id="'listrank' + rankType.id"
                  :href="'#tabrank' + rankType.id"
                  :aria-controls="rankType.id"
                  :class="{'active': index === 0}"
                  @click="switchRankTypeIndex(index)"
                >
                  <small class="font-weight-bold">{{ rankType.name }}</small>
                </a>
              </li>
            </ul>
          </div>

          <div class="col col-sm-4">
            <div
              class="tab-content gray-border float-right w-80"
              id="principal-tabContent"
              style="left: -1px;"
            >
              <div
                class="tab-pane fade show"
                role="tabpanel"
                :aria-labelledby="'#listprincipal' + principal.id"
                :id="'tabprincipal' + principal.id"
                v-for="(principal, tabIndex) in principalWithVessels"
                :key="principal.id"
                :class="{'active': tabIndex === 0}"
              >
                <div class="font-weight-bolder text-left">
                  <div class="form-group form-row m-0">
                    <div class="col col-sm-1 my-auto">
                      <input
                        type="checkbox"
                        class="form-control form-control-xs"
                        @click="selectVesselsByPrincipalIndex"
                      >
                    </div>
                    <div class="col col-sm-11 col-form-label py-1">
                      {{ principal.code }} Vessels
                    </div>
                  </div>
                </div> <hr class="m-0">
                <div class="overflow-auto" style="min-height: 10vh; max-height: 25vh">
                  <div
                    class="form-group form-row m-0"
                    v-for="vessel in principal.vessels"
                    :key="vessel.id"
                    :class="{'bg-gradient-success': params.vessels.some(addedvessel => addedvessel === vessel.id)}"
                  >
                    <div class="col col-sm-1">
                      <input
                        type="checkbox"
                        :value="vessel.id"
                        v-model="params.vessels"
                        class="form-control form-control-xs"
                      >
                    </div>
                    <div class="col col-sm-11 col-form-label py-1">
                      {{ vessel.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ul
              class="nav nav-tabs flex-column text-right mr-0 float-right w-20"
              role="tablist"
            >
              <li
                class="nav-item highlight-tab"
                v-for="(principal, index) in principalWithVessels"
                :key="principal.id"
              >
                <a
                  class="nav-link p-0 test rounded-0"
                  role="tab"
                  data-toggle="list"
                  :id="'listprincipal' + principal.id"
                  :href="'#tabprincipal' + principal.id"
                  :aria-controls="principal.id"
                  :class="{'active': index === 0}"
                  @click="switchPrincipalIndex(index)"
                >
                  <small class="font-weight-bold">{{ principal.code }}</small>
                </a>
              </li>
            </ul>
          </div>

          <div class="col col-sm-8 pl-0 mt-2">
            <div class="input-group rounded">
              <input
                type="text"
                placeholder="Search Name . . . ."
                class="form-control form-control-xs col col-sm-3"
                @keypress.enter="getCrewMonitoringReport(params)"
                v-model="params.crewName"
              >
              <input
                type="text"
                title="Date From"
                placeholder="Date From"
                class="form-control form-control-xs col col-sm-3"
                v-model="params.dateFrom"
                onmouseover="(this.type='date')"
                onmouseleave="(this.type='text')"
              >
              <input
                type="text"
                title="Date To"
                placeholder="Date To"
                class="form-control form-control-xs col col-sm-3"
                v-model="params.dateTo"
                onmouseover="(this.type='date')"
                onmouseleave="(this.type='text')"
              >

              <div
                class="input-group-prepend"
                title="Search"
              >
                <button
                  type="submit"
                  class="input-group-text input-group-append rounded-right"
                  @click="getCrewMonitoringReport(params)"
                >
                  <i class="fas fa-search" />
                </button>
              </div>
            </div>
          </div>


          <div class="col col-sm-4 text-right mt-2">
            <button
              @click="generateMonitoringReport(params)"
              class="btn btn-sm btn-outline-primary font-weight-bolder"
            >
              Generate Report
            </button>
          </div>
        </div>
      </div>
    </div>

    <table class="table table-hover table-bordered table-padding-1 mt-2">
      <thead>
        <tr class="table-header">
          <th class="col-index">
            #
          </th>
          <th>Name</th>
          <th>Rank</th>
          <th>Training Course</th>
          <th>Provider</th>
          <th>Date From</th>
          <th>Date To</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(crew, index) in crewMonitoringData"
          :key="crew.name.index"
        >
          <td>{{ index + 1 }}</td>
          <td>{{ crew.name }}</td>
          <td>{{ crew.rank }}</td>
          <td>{{ crew.course }}</td>
          <td>{{ crew.provider }}</td>
          <td>{{ crew.dateFrom | moment('DD MMM Y') }}</td>
          <td>{{ crew.dateTo | moment('DD MMM Y') }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import { formMixins } from "@/mixins/formMixins";
    import { DateService } from "@/service/date.service";

    export default {
        mixins: [ formMixins ],
        name: "CrewMonitoring",

        data() {
            return {
                params: {
                    dateFrom: DateService.addDays(DateService.dateNow(), -15),
                    dateTo: DateService.addDays(DateService.dateNow(), 15),
                    crewName: '',
                    courseTrainingProviders: [],
                    ranks: [],
                    vessels: [],
                  trainingProviders: [],
                  rankTypes: [],
                },
                providerIndex: 0,
                rankTypeIndex: 0,
                principalIndex: 0
            }
        },

        methods: {
            ...mapActions([
                'getCrewMonitoringReport',
              'getProviderWithCourses',
              'getRankTypeWithRanks',
              'getPrincipalWithVessels',
              'generateMonitoringReport',
            ]),
            selectCourseProviderByIndex(e) {
                this.params.courseTrainingProviders = e.target.checked ? this.providerWithCourses[this.providerIndex].courses.map(course => course.matrixId) : [];
            },

            switchProviderIndex(tabIndex) {
                this.providerIndex = tabIndex;
            },

            switchRankTypeIndex(rankTypeIndex) {
                this.rankTypeIndex = rankTypeIndex
            },

            selectRanksByRankTypeIndex(e) {
                this.params.ranks = e.target.checked ? this.rankTypeWithRanks[this.rankTypeIndex].ranks.map(ranks => ranks.id) : [];
            },

            switchPrincipalIndex(principalIndex) {
                this.principalIndex = principalIndex
            },

            selectVesselsByPrincipalIndex(e) {
                this.params.vessels = e.target.checked ? this.principalWithVessels[this.principalIndex].vessels.map(vessel => vessel.id) : [];
            },
        },

        computed: {
            ...mapGetters([
                'crewMonitoringData',
              'providerWithCourses',
              'rankTypeWithRanks',
              'principalWithVessels',
            ]),
        },

        created() {
            this.getProviderWithCourses();
            this.getRankTypeWithRanks();
            this.getPrincipalWithVessels();
            this.getCrewMonitoringReport(this.params);
        }
    }
</script>

<style scoped>

</style>
